import { render, staticRenderFns } from "./base-layout.vue?vue&type=template&id=7bd89910"
import script from "./base-layout.vue?vue&type=script&lang=js"
export * from "./base-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports